// extracted by mini-css-extract-plugin
export default {"project":"Project_project__mj-7u","project__text":"Project_project__text__tI2v8","container":"Project_container__l2w53"};